import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "../my-calendar.module.scss";
import { Card } from "primereact/card";
import ReactCountryFlag from "react-country-flag";

const MyCalendarEvent = ({
  title,
  subTitle,
  label,
  type,
  country,
  oneliner,
  start,
  end,
  id,
  handleSelectEvent,
  color,
  backgroundColor,
  status,
  process,
  due_date_utc,
  entityData,
  processData,
}) => {
  const renderStatus = (status) => (
    <p className="status">
      <span
        className="status-dot"
        style={{ background: status.primary_color }}
      />
      {status.name}
    </p>
  );

  return (
    <Card
      style={{
        borderInlineStartColor: color,
        backgroundColor: backgroundColor,
      }}
      onClick={() => {
        handleSelectEvent({
          title,
          subTitle,
          label,
          type,
          country,
          start,
          oneliner,
          id,
          status,
          end,
          color,
          process,
          due_date_utc,
          entityData,
          processData,
        });
      }}
    >
      <p className="event-service-name">{label}</p>
      <p className="event-name">{title}</p>
      <p className="event-entity-name">
        <ReactCountryFlag
          countryCode={entityData?.country || ""}
          svg
          className=""
        />
        {" " + entityData?.name}
      </p>
      {subTitle ? <p className="sub-title">{subTitle}</p> : null}
      {status && renderStatus(status)}
    </Card>
  );
};

MyCalendarEvent.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  status: PropTypes.shape({
    primary_color: PropTypes.string,
    secondary_color: PropTypes.string,
    name: PropTypes.string,
  }),
  country: PropTypes.string,
  oneliner: PropTypes.string,
  start: PropTypes.instanceOf(Date),
  end: PropTypes.instanceOf(Date),
  due_date_utc: PropTypes.instanceOf(Date),
  id: PropTypes.string,
  process: PropTypes.string,
  setIsOpen: PropTypes.func,
  setEventDetail: PropTypes.func,
  handleSelectEvent: PropTypes.func,
  entityData: PropTypes.object,
  processData: PropTypes.object,
};

export default MyCalendarEvent;
